import React, { useState } from 'react';
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { CompanyHolidayUsageSummary } from '@features/holidays/models/Holiday.model';
import { fetchAllUsersHolidaysInCompany } from '@features/holidays/services/HolidayService';
import { toExcelDownload } from '@features/reporting/services/ReportingService';
import { Moment } from "moment";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function DownloadHighLevelHolidayReportButton(props: Props) {
  const {selectedDate, disabled} = props;
  const [loading, setLoading] = useState(false);

  const downloadSummaryReport = async () => {
    if (disabled) return;
    try {
      setLoading(true);
      const summary: CompanyHolidayUsageSummary = await fetchAllUsersHolidaysInCompany(selectedDate.year());
      const data = summary.holidayUsages.map(u => ({
        'FirstName': u.firstName,
        'LastName': u.lastName,
        'Email': u.email,
        'TeamName': u.teamName,
        'DaysUsed': u.daysUsed,
        'TotalAllowance': u.totalAllowance,
      }))
      toExcelDownload(data, `Team Today holiday summary for ${summary.fromDate} to ${summary.toDate}`);
    } finally {
      setLoading(false);
    }
  }

  return (<OutlineButton size={ButtonSize.Medium}
                         disabled={disabled || loading}
                         text="reports-page.holidays-report.high-level-report"
                         click={downloadSummaryReport} />)
}

interface Props {
  selectedDate: Moment;
  disabled: boolean
}
